import React, { useEffect, useState } from "react";
import {
  Box,
  Grid2,
  Typography,
} from "@mui/material";

import { PrimaryFormLoadingActionButton } from "../../../Features/Table/GenericDraggableTable/TableStyles";
import PreviewChart from "./PreviewChart";
import EntityIdDisplayBox from "../Common/EntityIdDisplayBox";

const VisualizationPreview = ({ chartData, onSave, isEdit = false, isLoading = false, batteryInfo = {}, selectedEntity = null}) => {
  const [isSaveDisabled, setIsSaveDisabled] = useState(Object.keys(chartData).length <= 0);

  useEffect(() => {
    setIsSaveDisabled(Object.keys(chartData).length <= 0)
  }, [chartData])

  return (
    <Box sx={{height: '605px', flex: 1, borderRadius: '12px', backgroundColor: '#FFFFFF', p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
      <Grid2 container flexDirection={'column'} gap={1.5}>
        <Grid2 container justifyContent={'space-between'}>
          <Typography variant="fw500s16c000000" sx={{lineHeight: '28px'}}>Preview</Typography>
          <Grid2 container justifyContent={'flex-end'} alignItems={'center'} gap={1} sx={{ width: 'auto' }}>
            <EntityIdDisplayBox selectedEntity={selectedEntity} batteryInfo={batteryInfo} />
          </Grid2>
        </Grid2>
        <PreviewChart
          chartID={"preview-chart-binary"}
          binarySignalsData={chartData}
          key={"preview-chart-binary"}
          isLoading={isLoading}
          batteryInfo={batteryInfo}
          selectedEntity={selectedEntity}
        />
      </Grid2>
      <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
        <PrimaryFormLoadingActionButton
          onClick={onSave}
          disabled={isSaveDisabled}
        >
          {isEdit ? 'Save' : 'Create'}
        </PrimaryFormLoadingActionButton>
      </Box>
    </Box>
  );
};

export default VisualizationPreview;
